export default __webpack_public_path__ + "static/media/it-57.45e08899.svg";